import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import { setCookie } from '../../utils/cookie';
import { VERIFICATION_INTENT } from '../../constants/verification';

const PREFIX = 'ToggleMapPins';

const classes = {
  button: `${PREFIX}-button`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.button}`]: {
    minWidth: 'auto',
    padding: '8px 16px',
    border: 'none',
    margin: 0,
    borderRadius: 40,
    textTransform: 'initial',
    fontWeight: 600,
    display: 'inline-block',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
    '& > .MuiButton-label': {
      display: 'inline-block',
      verticalAlign: 'sub',
    },
  },
}));

function ToggleMapPins(props) {
  const { store, mediaQuery } = props;
  const { deliveryStore } = store;
  const { delivery, trackingCode } = deliveryStore;
  const { settings } = delivery;
  const allowRequestCode = settings.allow_request_code !== 'false';

  const handleToggleClick = () => {
    store.podStore.updateField('isPODFeedback', false);
    if (Boolean(store.deliveryStore.token)) {
      // Clear token from store
      store.deliveryStore.updateField('token', null);
      // Clear cookie
      setCookie('axl_shipment_token', '', 0);
      // Reload page
      store.deliveryStore.exitSession(() => (window.location.href = `/${trackingCode}`));
    } else {
      store.isViewPins = true;
      if (mediaQuery.isMobile) {
        store.podStore.startVerification(VERIFICATION_INTENT.LIVE_DETAILS);
        return;
      }
      store.deliveryStore.openDialog(1);
    }
  };

  if (!allowRequestCode) return null;

  return (
    <StyledBox className={classes.boxWrapper} my={mediaQuery.isMobile ? 2 : 3} style={{ padding: 10, margin: 0, border: 'none' }}>
      <Button onClick={handleToggleClick} className={classes.button} variant="contained" color="primary" disableElevation>
        {Boolean(store.deliveryStore.token) ? 'Hide live details' : 'View live details'}
      </Button>
    </StyledBox>
  );
}

export default ToggleMapPins;
